import React from 'react';
class LikesByList extends React.Component {
  
    render() {
        return(<ul class="likesby_full">
                <li class="dropdown">
                    <a id={'drop'+`${this.props.atrid}`+`${this.props.original_post.post_id}`} href="#" role="button" class="dropdown-toggle" data-toggle="dropdown">{this.props.original_post.likes ? this.props.original_post.likes:0}</a>
                    <ul class="dropdown-menu" role="menu" aria-labelledby={'drop'+`${this.props.atrid}`+`${this.props.original_post.post_id}`}>
                    <div class="parent-like">
                        <div class="liked_by">Liked By</div>
                        <div class="parent-close">
                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M15 5L5 15" stroke="#333333" stroke-opacity="0.5" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M5 5L15 15" stroke="#333333" stroke-opacity="0.5" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"></path></svg>
                        </div>
                    </div>
                    <div class="child-like">
                        {this.props.original_post.likes_by && this.props.original_post.likes_by.length > 0?
                            this.props.original_post.likes_by.map((items,key)=>
                                <li role="presentation">
                                    <div class="single-person">
                                        <div class="img-box">
                                            <a name="max" href={"/viewEmployee/"+items} target="_blank">
                                                <img src={this.props.userArr[items].profile_image}/>
                                            </a>
                                        </div>
                                        <div class="person-desc">
                                            <div class="name">
                                                <a name="max" href={"/viewEmployee/"+items} target="_blank">{this.props.userArr[items].name}</a>
                                            </div>
                                        </div>
                                    </div>
                                </li>
                            )
                            :""
                        }
                    </div>
                    </ul>
                </li>
            </ul>)
    }
}
export default LikesByList;


// WEBPACK FOOTER //
// ./src/components/bol/LikesByList.js